import styled, { keyframes } from 'styled-components';
const popupAnimation = keyframes `
 0% { transform: scale(0.25); }
 60% { transform: scale(1.33); }
 90% { transform: scale(0.9); }
 100% { transform: scale(1); }
`;
export const DotNotification = styled.span `
  position: absolute;
  left: 100%;
  top: 0;
  width: 6px;
  height: 6px;
  margin-left: 3px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors.primary};
  animation-name: ${popupAnimation};
  animation-duration: 380ms;
`;
//# sourceMappingURL=DotNotification.js.map